<template>
  <b-col class="storedropdown field mb-0 ms-0">
    <!-- {{ StoreDropDown.StoreOption[0].StoreBranchMapId }} -->
    <!-- {{ SelectedStore }} -->
    <Dropdown v-model="SelectedStore" :options="StoreDropDown.StoreOption" placeholder="Select store" filter
      optionLabel="Name" @change="navigate()" :class="{ active: SelectedStore }" :auto-filter-focus="true"
      :title="SelectedStore?.Name">
      <template #value="slotProps">
        <div v-if="slotProps.value" class="flex align-items-center">
          <span v-if="slotProps.value.StoreTypeName == 'Main Store'" class="main-store">MS</span>
          <span v-if="slotProps.value.StoreTypeName == 'Sub Store'" class="Sub-store">SS</span>
          <span v-if="slotProps.value.StoreTypeName == 'Department Store'" class="dep-store">DS</span>
          <span v-if="slotProps.value.StoreTypeName == 'Sub Department Store'" class="dep-store">SD</span>
          <div>{{ slotProps.value.Name }}</div>
        </div>
        <span v-else>
          {{ slotProps.placeholder }}
        </span>
      </template>
      <template #option="slotProps">
        <div class="flex align-items-center">
          <span v-if="slotProps.option.StoreTypeName == 'Main Store'" class="main-store">MS</span>
          <span v-if="slotProps.option.StoreTypeName == 'Sub Store'" class="Sub-store">SS</span>
          <span v-if="slotProps.option.StoreTypeName == 'Department Store'" class="dep-store">DS</span>
          <span v-if="slotProps.option.StoreTypeName == 'Sub Department Store'" class="dep-store">SD</span>
          <div>{{ slotProps.option.Name }}</div>
        </div>
      </template>
    </Dropdown>
  </b-col>
</template>

<script lang="ts">
import {
  computed,
  defineComponent,
  ref,
  onMounted,
  watch,
  onUnmounted,
} from "vue";
import { value } from "dom7";
import { RouterLink, RouterView, useRouter, useRoute } from "vue-router";
import commonservice from "../../Service/StoreService";

const profilelist = [
  {
    label: "Admin",
    key: "jay gatsby",
  },
  {
    label: "Daisy Buchanan",
    key: "daisy buchanan",
  },
  {
    type: "divider",
    key: "d1",
  },
  {
    label: "Nick Carraway",
    key: "nick carraway",
  },
  {
    label: "Others",
    key: "others1",
    children: [
      {
        label: "Jordan Baker",
        key: "jordan baker",
      },
      {
        label: "Tom Buchanan",
        key: "tom buchanan",
      },
      {
        label: "Others",
        key: "others2",
        children: [
          {
            label: "Chicken",
            key: "chicken",
          },
          {
            label: "Beef",
            key: "beef",
          },
        ],
      },
    ],
  },
];

export default defineComponent({
  setup(props, { emit }) {
    const router = useRouter();
    const QueryString = useRoute();
    let storedata = ref("");
    let SelectedStore: any = ref();
    let SessionStoreId: any = ref();

    let List = ref([]);

    //get local storage session data
    let SessionUserData = localStorage.getItem("UsersData");
    let usersData;
    if (SessionUserData !== null) {
      usersData = JSON.parse(SessionUserData);
    }

    SessionStoreId.value = localStorage.getItem("StoreId");

    onMounted(() => {
      LoadStore();
    });
    // onUnmounted(() => {
    //   SelectedStore.value = {}
    // });



    let StoreDropDown: any = ref({
      StoreOption: [],
    });

    //Load Store Drop down
    async function LoadStore() {
      debugger;
      // let result = await commonservice.getStoreListByUserId(
      //   usersData.UserId,
      //   usersData.OrganizationId,
      //   usersData.Admin,
      //   usersData.BranchId
      // );
      let result = await commonservice.StoreDropDownListByUserId(
        usersData.UserId,
        usersData.OrganizationId,
        usersData.Admin,
        usersData.BranchId
      );


      StoreDropDown.value.StoreOption = result["result"]
        .filter(
          (x) => x.IsActive == true
        )
        .map((item) => ({
          Name: item.Name + ' - ' + item.CurrentBranchName,
          Id: item.Id,
          StoreCode: item.Code,
          StoreTypeId: item.StoreTypeId,
          StoreTypeName: item.StoreTypeName,
          StoreBranchMapId: item.StoreBranchMapId,
          BranchId: item.BranchId,
          IsZeroBill: item.IsZeroBill,
          IsCamp: item.IsCamp,
          SiteId: item.SiteId,
        }));

      // if (QueryString.query.Id) {
      //   let StoreValue = StoreDropDown.value.StoreOption.find(
      //     (x) => x.Id == QueryString.query.Id
      //   );

      //   if (StoreValue) {
      //     SelectedStore.value = StoreValue;
      //   }
      // }

      if (SessionStoreId.value) {
        let StoreValue = StoreDropDown.value.StoreOption.find(
          (x) => x.Id == SessionStoreId.value
        );

        if (StoreValue) {
          SelectedStore.value = StoreValue;
        }
      }

      // Sort the StoreOption array alphabetically by Name
      StoreDropDown.value.StoreOption.sort((a: any, b: any) => {
        const nameA = typeof a.Name === 'string' ? a.Name.toLowerCase() : '';
        const nameB = typeof b.Name === 'string' ? b.Name.toLowerCase() : '';
        return nameA.localeCompare(nameB);
      });
    }

    function navigate() {
      debugger;
      console.log(SelectedStore);
      console.log(StoreDropDown.value.StoreOption);
      let TabIndex = {
        Indexval: 0,
      };
      localStorage.removeItem("TabIndex");
      localStorage.setItem("TabIndex", JSON.stringify(TabIndex));

      localStorage.removeItem("RequestSubTabIndex");
      localStorage.setItem("RequestSubTabIndex", JSON.stringify(TabIndex));

      if (SelectedStore.value["StoreTypeName"] == "Main Store") {
        let MainStore: any = "1";
        router.push({
          name: "StoreTabDetails",
          query: {
            status: MainStore,
            Id: SelectedStore.value["Id"],
            Type: "StoreId",
            storename: SelectedStore.value["Name"],
            storebranchmapid: SelectedStore.value["StoreBranchMapId"],
            BranchId: SelectedStore.value["BranchId"],
            IsZeroBill: SelectedStore.value["IsZeroBill"],
            SiteId: SelectedStore.value["SiteId"]
          },
        });
      } else if (SelectedStore.value["StoreTypeName"] == "Sub Store") {
        let SubStore: any = "2";
        router.push({
          name: "StoreTabDetails",
          query: {
            status: SubStore,
            Id: SelectedStore.value["Id"],
            Type: "StoreId",
            storename: SelectedStore.value["Name"],
            storebranchmapid: SelectedStore.value["StoreBranchMapId"],
            BranchId: SelectedStore.value["BranchId"],
            IsZeroBill: SelectedStore.value["IsZeroBill"],
            SiteId: SelectedStore.value["SiteId"]
          },
        });
      } else if (SelectedStore.value["StoreTypeName"] == "Department Store") {
        let DeptStore: any = "3";
        router.push({
          name: "StoreTabDetails",
          query: {
            status: DeptStore,
            Id: SelectedStore.value["Id"],
            Type: "StoreId",
            storename: SelectedStore.value["Name"],
            storebranchmapid: SelectedStore.value["StoreBranchMapId"],
            BranchId: SelectedStore.value["BranchId"],
            IsZeroBill: SelectedStore.value["IsZeroBill"],
            IsCamp: SelectedStore.value["IsCamp"],
            SiteId: SelectedStore.value["SiteId"]
          },
        });
      }

      let storedetails = ref({
        StoreId: SelectedStore.value["Id"],
        StoreBranchmapId: SelectedStore.value["StoreBranchMapId"],
        BranchId: SelectedStore.value["BranchId"],
        IsZeroBill: SelectedStore.value["IsZeroBill"],
        IsCamp: SelectedStore.value["IsCamp"],
        SiteId: SelectedStore.value["SiteId"],
      })

      localStorage.setItem("StoreId", SelectedStore.value["Id"]);
      emit('StoreChanged', storedetails.value)
    }

    let filterdata = ref("");
    let currentPath = ref("");
    let filterotherdata = ref();

    currentPath.value = String(QueryString.path);

    watch(
      () => QueryString.path,
      (newVal) => {
        if (newVal === "/Masters") {
          SelectedStore.value = "";
        }
      }
    );

    watch(
      () => StoreDropDown.value.StoreOption[0]?.StoreBranchMapId,
      (newVal) => {
        if (QueryString.path == "/StoreTabDetails") {
          filterdata.value = StoreDropDown.value.StoreOption.filter(
            (x) => x.Id == QueryString.query.Id
          );
          filterotherdata.value = StoreDropDown.value.StoreOption.filter(
            (x) => x.Id != QueryString.query.Id
          );

          if (filterdata.value.length != 0) {
            SelectedStore.value = {
              Id: filterdata.value[0]?.["Id"],
              Name: filterdata.value[0]?.["Name"],
              StoreBranchMapId: filterdata.value[0]?.["StoreBranchMapId"],
              status: filterdata.value[0]?.["StoreTypeId"],
              StoreTypeName: filterdata.value[0]?.["StoreTypeName"],
              BranchId: filterdata.value[0]?.["BranchId"],
              IsZeroBill: filterdata.value[0]?.["IsZeroBill"],
              IsCamp: filterdata.value[0]?.["IsCamp"],
              SiteId: filterdata.value[0]?.["SiteId"],
            };

            navigate();
          } else {
            SelectedStore.value = {
              Id: filterotherdata.value[0]?.["Id"],
              Name: filterotherdata.value[0]?.["Name"],
              StoreBranchMapId: filterotherdata.value[0]?.["StoreBranchMapId"],
              status: filterotherdata.value[0]?.["StoreTypeId"],
              StoreTypeName: filterotherdata.value[0]?.["StoreTypeName"],
              BranchId: filterotherdata.value[0]?.["BranchId"],
              IsZeroBill: filterotherdata.value[0]?.["IsZeroBill"],
              IsCamp: filterotherdata.value[0]?.["IsCamp"],
              SiteId: filterotherdata.value[0]?.["SiteId"],
            };

            navigate();
          }

        }
      }
    );
    return {
      List,
      navigate,
      storedata,
      StoreDropDown,
      SelectedStore,
    };
  },
});
</script>

<style lang="scss" scoped>
@import "../../../../assets/variables.scss";

.p-dropdown {
  align-items: center;
  width: 100%;
  background: $HeaderBg !important;
  border: 1px solid #ced4da;
  transition: background-color 0.2s, color 0.2s, border-color 0.2s,
    box-shadow 0.2s;
  border-radius: 6px;
  margin-left: 20px;
  height: 40px;
}

.p-dropdown-panel .p-dropdown-items {
  padding: 0.75rem 0;
  background-color: black !important;
}

.p-dropdown-items-wrapper {
  overflow: auto;
  background-color: black !important;
}

.p-dropdown-items-wrapper ul li div {
  width: 150px;
  display: flex;
}

.p-dropdown-items {
  background-color: black !important;
}

.p-dropdown-label div {
  color: white;
  display: flex;
  width: 150px;
}

.p-dropdown-panel {
  background: #000000 !important;
  color: #495057;
  border: 0 none;
  border-radius: 6px;
  box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
}

.p-dropdown-panel .p-dropdown-items .p-dropdown-item:not(.p-highlight):not(.p-disabled):hover {
  color: #495057;
  background: #000000 !important;
}

.p-dropdown-panel .p-dropdown-items .p-dropdown-item.p-highlight {
  color: #fdfdfd !important;
  background: #040404 !important;
}

.main-store {
  color: #000000;
  font-size: 10px;
  border-radius: 50%;
  background-color: #cdd0fb;
  padding: 10px;
  // width: 120px;
  // height: 120px;
  margin-right: 10px;
}

.Sub-store {
  color: #000000;

  font-size: 10px;
  border-radius: 50%;
  background-color: #fff3cc;
  padding: 10px;
  // width: 120px;
  // height: 120px;
  margin-right: 10px;
}

.dep-store {
  color: #000000;

  font-size: 10px;
  border-radius: 50%;
  background-color: #ffcccc;
  padding: 10px;
  // width: 120px;
  // height: 120px;
  margin-right: 10px;
}

.storedropdown .p-inputtext {
  padding: 0.3rem 0.75rem !important;
}

.storedropdown .p-dropdown {
  height: 40px;
  width: 265px;
  background-color: #000000 !important;
}

.storedropdown .p-dropdown.active {
  border: 1px solid #0148e2 !important;
}

// @media only screen and (max-width: 575px) {
// .storedropdown .p-dropdown{
//   width: 250px;
// }

// }
@media only screen and (max-width: 430px) {
  .storedropdown .p-dropdown {
    width: 152px;
  }
}
</style>
